import memoize from "memoize-one";
import { isEqual } from "lodash";
import { IDoor } from "helpers/door-collection";
import { MetricsDataForCell, MetricsKind } from "helpers/metrics/types";
import { Column, GridApi } from "ag-grid-community";
import { renameMetricColId } from "../column-formula/ag-grid-helper";

export const generateDoorMap = memoize((doors: IDoor[]): Map<string, IDoor> => {
    const map = new Map<string, IDoor>();
    doors.forEach((d) => {
        if (!d) {
            return;
        }
        map.set(d.id, d);
    });
    return map;
}, isEqual);

export const getMetricValuesFromNewBagData = (
    deliveryId: string | null | undefined,
    doorsMap: Map<string, IDoor>,
    dimensions: string[],
    value: string,
    useSize: boolean,
    size?: string
): MetricsDataForCell => {
    let doorIdValue: string;
    let currentDeliveryIdValue;
    let currentSize: string;

    if (deliveryId === "") {
        currentDeliveryIdValue = null;
        doorIdValue = dimensions[0];
        if (size) {
            currentSize = dimensions[1];
        }
    } else {
        currentDeliveryIdValue = dimensions[0];
        doorIdValue = dimensions[1];
        if (size) {
            currentSize = dimensions[2];
        }
    }

    let shouldSkip = false;

    if (!deliveryId) {
        if (!doorsMap.has(doorIdValue)) {
            shouldSkip = true;
        }
    } else {
        if (currentDeliveryIdValue !== deliveryId || !doorsMap.has(doorIdValue)) {
            shouldSkip = true;
        }
    }

    if (useSize && size && size !== currentSize) {
        shouldSkip = true;
    }

    return {
        doorIdValue,
        currentDeliveryIdValue,
        shouldSkip,
        bulkCount: +value,
        currentSize,
    };
};

export const getMetricValuesFromOldBagData = (
    deliveryId: string | null | undefined,
    doorsMap: Map<string, IDoor>,
    col: string[],
    useSize: boolean,
    size?: string
): MetricsDataForCell => {
    let doorIdValue;
    let currentDeliveryIdValue;
    let bulkCount: number;
    let currentSize: string;
    if (deliveryId === "") {
        currentDeliveryIdValue = null;
        doorIdValue = col[0];
        if (size) {
            currentSize = col[1];
            bulkCount = +col[2];
        } else {
            bulkCount = +col[1];
        }
    } else {
        currentDeliveryIdValue = col[0];
        doorIdValue = col[1];
        if (size) {
            currentSize = col[2];
            bulkCount = +col[3];
        } else {
            bulkCount = +col[2];
        }
    }

    let shouldSkip = false;

    if (!deliveryId) {
        if (!doorsMap.has(doorIdValue)) {
            shouldSkip = true;
        }
    } else {
        if (currentDeliveryIdValue !== deliveryId || !doorsMap.has(doorIdValue)) {
            shouldSkip = true;
        }
    }

    if (useSize && size && size !== currentSize) {
        shouldSkip = true;
    }

    return {
        doorIdValue,
        currentDeliveryIdValue,
        shouldSkip,
        bulkCount: bulkCount || 0,
        currentSize,
    };
};

export const getColumnValuesFromFormulaParameters = (gridApi: GridApi, kind: MetricsKind, column: Column): any[] => {
    const colId = renameMetricColId(column.getColId(), kind);
    const values = [];

    gridApi.forEachNodeAfterFilter((rowNode) => {
        values.push(gridApi.getValue(colId, rowNode));
    });

    return values;
};
